/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'path-match-with-objects';
const prefix = `${moduleName}.${componentName}`;

export const enableMatchCaseLabel = `${prefix}.enableMatchCaseLabel`;
export const matchDecodedStringLabel = `${prefix}.matchDecodedStringLabel`;

export const ENGLISH = {
    [enableMatchCaseLabel]: 'Enable Match Case',
    [matchDecodedStringLabel]: 'Match Decoded String',
};
